import React from "react"
import PropTypes from "prop-types"
import SelectField from "../select-field"
import TextField from "../text-field"
import { Container } from "./styles"

const PhoneSelect = ({ name, placeholder, selectValue, textValue, handleInputChange, phoneCodes, simpleForm }) => {
  const onChange = (name, value) => {
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <Container>
      <SelectField
        name={`${name}_country_id`}
        options={phoneCodes}
        value={selectValue}
        handleInputChange={onChange}
        blank="-"
        simpleForm={simpleForm}
      />
      <TextField
        name={name}
        placeholder={placeholder}
        value={textValue}
        handleInputChange={onChange}
        simpleForm={simpleForm}
      />
    </Container>
  )
}

PhoneSelect.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  selectValue: PropTypes.number,
  textValue: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  phoneCodes: PropTypes.array.isRequired
}

PhoneSelect.defaultProps = {
  placeholder: "Enter phone number",
  handleInputChange: undefined,
  phoneCodes: []
}

export default PhoneSelect
